import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class FeatureFlags extends Component {
    static propTypes = {
        height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        iconColor: PropTypes.string
    };

    static defaultProps = {
        width: 22,
        height: undefined,
        iconColor: '#000'
    };

    render() {
        const { height, width, iconColor } = this.props;

        return (
            <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" width={width} height={height}
                viewBox="0 0 120 120" >
                <g>
                    <path fill={iconColor} d="M60,115.68c-9.32,0-18.09-3.63-24.68-10.23c-6.59-6.59-10.22-15.36-10.22-24.68c0-9.32,3.63-18.09,10.23-24.68
           c1.37-1.37,3.58-1.37,4.95,0c1.37,1.37,1.37,3.58,0,4.95c-5.27,5.27-8.17,12.28-8.17,19.73c0,7.46,2.9,14.46,8.17,19.74
           c5.27,5.27,12.28,8.17,19.73,8.17s14.46-2.9,19.74-8.17c10.88-10.88,10.88-28.59,0-39.47c-1.37-1.37-1.37-3.58,0-4.95
           c1.37-1.37,3.58-1.37,4.95,0c6.59,6.59,10.22,15.36,10.22,24.68c0,9.33-3.63,18.09-10.22,24.68
           C78.09,112.05,69.32,115.68,60,115.68z"/>
                </g>
                <g>
                    <path fill={iconColor} d="M60,88.28c-1.93,0-3.5-1.57-3.5-3.5V7.9c0-1.93,1.57-3.5,3.5-3.5c1.93,0,3.5,1.57,3.5,3.5v76.88
           C63.5,86.71,61.93,88.28,60,88.28z"/>
                </g>
                <path fill={iconColor} d="M69.27,9.03c0,0,11.86-0.38,21.84,3.2s16.94,5.08,25.04,4.14l-13.93,10.35l12.05,11.67
       c0,0-16.56,1.13-24.09-2.64s-20.33-1.13-20.33-1.13L69.27,9.03z"/>
            </svg>
        );
    }
}
